import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import DefaultProfileTeaser from './Teaser';

import { ProfileDefault } from '../../../types/uncinc_profile/profile';

interface DefaultProfileProps {
  entity: ImmutableEntity<ProfileDefault>;
  classes: string;
}

const NodeProfileWrapper: React.FC<DefaultProfileProps> = ({ entity, classes = '' }) => (<DefaultProfileTeaser entity={entity} classes={classes} />);

export default NodeProfileWrapper;
